import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import EmptySurvey from 'components/surveys/EmptySurvey';
import SurveyAttributesList from './SurveyAttributesList';

const CustomSurveyList = ({
  deleteCustomSurvey,
  customSurveys,
  isDisabled,
  onAddSurvey,
}) => {
  const locationCount = customSurveys.length;
  const disabledStyle = isDisabled ? 'disable-actions' : null;
  const customSurveyList = customSurveys.map(customSurvey => {
    return (
      <SurveyAttributesList
        key={customSurvey.id}
        locationCount={locationCount}
        customSurvey={customSurvey}
        deleteCustomSurvey={deleteCustomSurvey}
      />
    );
  });

  if (customSurveyList.length == 0) {
    return <EmptySurvey onAddSurvey={onAddSurvey} />;
  }

  return (
    <Table
      hover
      className={` survey-table styled-box-shadow ${disabledStyle}`}
      responsive
    >
      <thead>
        <tr>
          <th>Name</th>
          <th>Reward</th>
          <th className="table-separator-th">Quick Links</th>
          <th className="table-separator-th">Promote</th>
          <th className="action-head-120 table-separator-th">Action</th>
        </tr>
      </thead>
      <tbody>{customSurveyList}</tbody>
    </Table>
  );
};

CustomSurveyList.propTypes = {
  deleteCustomSurvey: PropTypes.func.isRequired,
  customSurveys: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ),
};

CustomSurveyList.defaultProps = {
  customSurveys: [],
};

export default CustomSurveyList;



// WEBPACK FOOTER //
// ./src/components/customSurvey/CustomSurveyList.js